/******************************************************************************************
 *	Session Storage
 *******************************************************************************************
 *
 * Session Storage service saves data using the window.sessionStorage object.
 * It allows saving objects and other non-primitive types by stringifying the data passed in and parsing the output data.
 *
 */
(function() {
  

  angular.module('rcServices.sessionStorage', []).service(
    'SessionStorage',
    /* @ngInject */
    function(_, $window) {
      //Store keys so that clear() only removes SessionStorage keys.
      var keys = [];

      this.set = function(key, value) {
        if (!_.includes(keys, key)) {
          keys.push(key);
        }
        $window.sessionStorage.setItem(key, JSON.stringify(value));
      };

      this.get = function(key) {
        return JSON.parse($window.sessionStorage.getItem(key));
      };

      this.remove = function(key) {
        $window.sessionStorage.removeItem(key);
      };

      this.clear = function() {
        _.forEach(keys, key => {
          this.remove(key);
        });
      };
    }
  );
})();
